import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingManagementFeeSettingModel extends Model {
  @attr('number') cleaningFeePercentage!: number;
  @attr('number') accommodationPercentage!: number;

  @belongsTo('booking', {
    inverse: 'bookingManagementFeeSetting',
    async: false,
  })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-management-fee-setting': BookingManagementFeeSettingModel;
  }
}
